module.exports = __webpack_public_path__ + "static/img/talk.d15aa83.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/detailed/talk.svg
// module id = wXRX
// module chunks = 0